export const WrapupRule = {
    "UpdateDataCall":"UpdateDataCall",
    "getACDDispositions":"getACDDispositions",
    "getCampaignDispositions":"getCampaignDispositions",
    "GetDispositionsAndNumbers":"GetDispositionsAndNumbers",
    "disposeACDCall":"disposeACDCall",
    "disposeCampaingCall":"disposeCampaingCall",
    "reprogramCampaignCall":"reprogramCampaignCall",
    "reprogramAcdCall":"reprogramAcdCall",
    "Disposition":"Disposition",
    "getPhoneNumbers":"getPhoneNumbers",
    "getDispositions":"getDispositions",
    "saveDisposition":"saveDisposition",
    "sendClientChatMessage":"sendClientChatMessage",
    "getSupervisorsToChat":"getSupervisorsToChat",
    "getChatHistory":"getChatHistory",
};


// WEBPACK FOOTER //
// ./src/BusinessRule/WrapupRule.js